import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./inputphone.scss";

const InputPhone = ({ setValue, value }) => {
  return (
    <div className="phoneinput-div">
      <PhoneInput
        disableDropdown
        countryCodeEditable={false}
        placeholder="Enter your mobile number"
        country={"in"}
        containerClass="phoneinput"
        id="mobileNumber"
        name="mobileNumber"
        value={value}
        onChange={(e) => setValue(e)}
      />
    </div>
  );
};

export default InputPhone;
